import { styled, Badge, BadgeProps } from "@mui/material";

interface Props extends BadgeProps {
	statusColor: string;
	anchorVertical: "bottom" | "top";
	anchorHorizontal: "left" | "right";
	disableAnimation?: boolean;
}

export const StatusBadge: React.FunctionComponent<Props> = (props) => {
	const StyledBadge = styled(Badge)(({ theme }) => ({
		"& .MuiBadge-badge": {
			backgroundColor: props.statusColor,
			color: props.statusColor,
			boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
			...(props.disableAnimation
				? {}
				: {
						"&::after": {
							position: "absolute",
							top: 0,
							left: 0,
							width: "100%",
							height: "100%",
							borderRadius: "50%",
							animation: "ripple 1.2s infinite ease-in-out",
							border: "1px solid currentColor",
							content: '""',
						},
				  }),
		},
		"@keyframes ripple": {
			"0%": {
				transform: "scale(.8)",
				opacity: 1,
			},
			"100%": {
				transform: "scale(2.4)",
				opacity: 0,
			},
		},
	}));

	return (
		<StyledBadge
			overlap="circular"
			anchorOrigin={{
				vertical: props.anchorVertical,
				horizontal: props.anchorHorizontal,
			}}
			variant="dot"
		>
			{props.children}
		</StyledBadge>
	);
};
